import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'smgo';

  menuList: Array<any> = [
    { label: 'ABOUT US', value: 'about-us' },
    { label: 'IDEA & VISION', value: 'idea-vision' },
    // { label: 'CUSTOMER', value: 'customers' },
    { label: 'ACTIVITIES', value: 'activities' },
    { label: 'CONTACT US', value: 'contact-us' }
  ]
}
